import inputIsActive from './inputIsActive';
export var isConditionallyRequired = function isConditionallyRequired(element, conditionalRequirements) {
  var requirement = element.get('IsConditionallyRequired');

  if (conditionalRequirements.get(requirement)) {
    return true;
  }

  return false;
};

var inputIsRequired = function inputIsRequired(element, coApplicantIsActive, conditionalRequirements) {
  var active = inputIsActive(element, coApplicantIsActive);

  if (active) {
    if (Boolean(element.get('IsRequired'))) {
      return true;
    }

    if (Boolean(element.get('IsConditionallyRequired'))) {
      return isConditionallyRequired(element, conditionalRequirements);
    }
  }

  return false;
};

export default inputIsRequired;